module.exports = __webpack_public_path__ + "files/129cd2c499187fc14dc55a4161648f27.png";